/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PropertySharingIdentifierSelector } from './PropertySharingIdentifierSelector';
/**
 * Parameter resolved from a reusable external-identifier category.
 */
export type PropertySharingIdentifierPart = {
    /**
     * Discriminator for external identifier selection.
     */
    kind: PropertySharingIdentifierPart.kind;
    /**
     * Category resolved separately for each property.
     */
    selector: PropertySharingIdentifierSelector;
    /**
     * Raw spelling by default; normalized spelling only when explicitly selected.
     */
    field: PropertySharingIdentifierPart.field;
};
export namespace PropertySharingIdentifierPart {
    /**
     * Discriminator for external identifier selection.
     */
    export enum kind {
        IDENTIFIER = 'identifier',
    }
    /**
     * Raw spelling by default; normalized spelling only when explicitly selected.
     */
    export enum field {
        VALUE = 'value',
        NORMALIZED_VALUE = 'normalizedValue',
    }
}

